import styled from "@emotion/styled";

import { SwipeableContent } from "../../../Default/LekUI/SwipableDrawer";

const SkeletonContainer = styled("div")`
  padding: 8px;
`;

function DefaultOptionDetail({ dispatch, actions, ...props }) {
	const renderHeader = () => {
		return (
			<div className="default-question-option--header">
				{props.renderHeader()}
			</div>
		);
	};

	const renderContent = () => {
		if (props.isLoading) {
			if (props.Skeleton) {
				return <SkeletonContainer>{props.Skeleton}</SkeletonContainer>;
			}

			return <div>Ładowanie...</div>;
		}

		return (
			<div className="default-question-option">
				{renderHeader()}
				{props.renderContent(props.data)}
			</div>
		);
	};

	const close = () => {
		if (dispatch) {
			return dispatch(actions.toggleSettings(props.actionKey));
		}

		return actions.toggleSettings(props.actionKey);
	};

	return (
		<SwipeableContent onClose={close} isOpen={props.isOpen}>
			{renderContent()}
		</SwipeableContent>
	);
}

export default DefaultOptionDetail;
